import Adobe from './assets/Adobe.svg';
import Decathlon from './assets/Decathlon.svg';
import Hubspot from './assets/Hubspot.svg';
import Invision from './assets/Invision.svg';
import MicrosoftLogo from './assets/Microsoft_Logo.svg';
import Nintendo from './assets/Nintendo.svg';
import Panasonic from './assets/Panasonic.svg';
import TMobile from './assets/T-Mobile.svg';

const LogoOptions = {
  adobe: Adobe,
  decathlon: Decathlon,
  hubspot: Hubspot,
  invision: Invision,
  microsoft: MicrosoftLogo,
  nintendo: Nintendo,
  panasonic: Panasonic,
  't-mobile': TMobile,
};

export type SetupLogoIconProps = {
  name: keyof typeof LogoOptions;
};

export const SetupLogoIcon = ({ name }: SetupLogoIconProps): JSX.Element => {
  return <img src={LogoOptions[name]} alt={LogoOptions[name]} />;
};
